import type { ConfigType } from '@plone/registry';
import Search from '@plone/volto/components/theme/Search/Search';

export default function install(config: ConfigType) {
  config.addonRoutes = [
    ...config.addonRoutes,
    {
      path: ['/search', '/**/search'],
      component: Search,
    },
  ];
  return config;
}
